<template>
  <div class="file-download-button">
    <div
      class="file-download-button_content"
      :class="{ narrow: narrow, download: download, isloading: isloading, small: small }"
      @click.stop="$_previewPopUpOpen(num)"
      @mouseenter="mouseShowDeleteBtn = true"
      @mouseleave="mouseShowDeleteBtn = false"
    >
      <img :src="$_getFilePhoto(textLabel)" alt="" />
      <p v-if="isloading" class="file-name">
        {{ textLabel }}
      </p>
      <p v-else class="file-name">
        {{ $_getFileName(textLabel) }}{{ $_getFileExtension(textLabel) }}
      </p>
      <div class="file-download-button_content__icon">
        <div v-if="download" download @click.stop="$_downloadClick(textLabel)">
          <i class="icon icon-cloud-download" />
        </div>
        <div v-if="_showDeleteBtn" @click.stop="$_deleteFile()">
          <i class="icon icon-cancel" />
        </div>
      </div>
      <div v-if="isloading && !mouseShowDeleteBtn" class="isloading-wrap">
        <LoadingAnimate primary />
      </div>
    </div>
    <PreviewPopUp
      :ref="'popup' + num"
      :pop-up-active="previewPopUpActive"
      :text-label="textLabel"
      :num="num"
      download
      @click="$_previewPopUpClose()"
    />
  </div>
</template>
<script>
import filePhotos from '@/spare/file-photos';

export default {
  name: 'FileDownloadButton',
  props: {
    narrow: {
      type: Boolean,
      default: false,
    },
    download: {
      type: Boolean,
      default: true,
    },
    upload: {
      type: Boolean,
      default: false,
    },
    textLabel: {
      type: String,
      default: '',
    },
    num: {
      type: Number,
      default: 0,
    },
    isloading: {
      type: Boolean,
      default: false,
    },
    previewUrl: {
      type: String,
      default: '',
    },
    small: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    showDeleteBtn: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    mouseShowDeleteBtn: false,
    filePhotos: filePhotos.filePhotos,
    previewPopUpActive: false,
  }),
  computed: {
    _showDeleteBtn() {
      if (!this.showDeleteBtn) return false;
      if (this.showDeleteBtn || (this.upload && !this.isloading) || this.mouseShowDeleteBtn) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    $_getFilePhoto(textLabel) {
      if (!textLabel) return;
      let fileExtension = this.$_getFileExtension(textLabel).substring(1).toLowerCase();
      if (!fileExtension) return require('@/assets/image/thumbnail_file/other-other.png');
      let file;
      this.filePhotos.forEach(filePhoto => {
        if (filePhoto.file.includes(fileExtension)) {
          file = filePhoto.image;
        }
      });
      return file ? file : require('@/assets/image/thumbnail_file/other-other.png');
    },
    $_deleteFile() {
      this.$emit('deleteFile');
    },
    $_getFileName(url) {
      if (url) {
        let filename = url.toString().match(/.*\/(.+?)\./);
        if (filename && filename.length > 1) {
          return decodeURI(filename[1]);
        }
      }
      return '';
    },
    $_getFileExtension(url) {
      if (!url) return;
      return (url = url.substring(1 + url.lastIndexOf('/')).split('?')[0])
        .split('#')[0]
        .substring(url.lastIndexOf('.'));
    },
    $_previewPopUpClose() {
      this.$emit('click');
      this.$emit('scroll-click');
      this.previewPopUpActive = false;
    },
    $_previewPopUpOpen() {
      if (this.isDisabled || this.isloading) return;
      this.$emit('click');
      this.$emit('no-scroll');
      this.previewPopUpActive = true;
    },
    $_downloadClick(text) {
      const fileName = this.$_getFileName(text) + this.$_getFileExtension(text);
      fetch(text).then(function (t) {
        return t.blob().then(b => {
          var a = document.createElement('a');
          a.href = URL.createObjectURL(b);
          a.setAttribute('download', fileName);
          a.click();
        });
      });
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/component/file-download-button';
</style>
